"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 其它公告页
 */
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
//主表配置
loadtabledata();
function loadtabledata() {
    //最新公告
    $("#dataview").emdataview({
        dataurl: {
            hostname: "anoticeurl",
            url: "api/security/ann",
            params: {
                ann_type: stockInfo.type,
                client_source: 'web',
                stock_list: stockInfo.code
            }
        },
        ajaxoptions: { jsonp: "cb" },
        totalfield: "data.total_hits",
        datafield: "data.list",
        pagesize: 50,
        allcolumnhover: false,
        urlkeyvalues: {
            pagenumber: "page_index",
            pagesize: "page_size",
            sortname: "st",
            sortorder: "sr"
        },
        columns: {
            title: {
                formatter: function (value, item, i, field) {
                    return "<div class=\"ellipsis\" style=\"width:675px;\" title=\"" + fieldtools_1["default"].escapeHTML(fieldtools_1["default"].strformat(value)) + "\"><a href=\"/notices/detail/" + stockInfo.code + "/" + item.art_code + ".html\">" + value + "</a></div>";
                }
            },
            type: {
                formatter: function (value, item, i, field) {
                    var _a;
                    var type = ((_a = item.columns[0]) === null || _a === void 0 ? void 0 : _a.column_name) || "公司公告";
                    return "<div class=\"ellipsis gglx\" style=\"width:190px;\"  title=\"" + fieldtools_1["default"].escapeHTML(fieldtools_1["default"].strformat(type)) + "\">" + fieldtools_1["default"].strformat(type) + "</div>";
                }
            },
            notice_date: emfield.date
        }
    });
}
